import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      width="11.755"
      height="15.673"
      x=".122"
      y=".735"
      fill="#D80000"
      stroke="#051045"
      rx="1"
      transform="translate(7 5)"
    />
  </svg>
);

const IconRedCardWithoutHand = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconRedCardWithoutHand;
